import React from "react"
import FormControl from "@mui/material/FormControl"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import OutlinedInput from "@mui/material/OutlinedInput"
import Checkbox from "@mui/material/Checkbox"
import ListItemText from "@mui/material/ListItemText"
import i18n from "@/i18n"
import {
  STATUS_CANCELLED,
  STATUS_CONFIRMED,
  STATUS_NO_SHOW,
  STATUS_PENDING,
  STATUS_REMOVED,
  STATUS_WALK_IN,
} from "@/constants/reservations"

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 6 + 8,
      width: 250,
    },
  },
}

const LABELS = {
  [STATUS_CONFIRMED]: i18n.t("app.reservation.status.confirmed"),
  [STATUS_WALK_IN]: i18n.t("app.reservation.status.walk_in"),
  [STATUS_PENDING]: i18n.t("app.reservation.status.pending"),
  [STATUS_NO_SHOW]: i18n.t("app.reservation.status.no_show"),
  [STATUS_CANCELLED]: i18n.t("app.reservation.status.cancelled"),
  [STATUS_REMOVED]: i18n.t("app.reservation.status.removed"),
}

const STATUSES = [STATUS_CONFIRMED, STATUS_WALK_IN, STATUS_PENDING, STATUS_NO_SHOW, STATUS_CANCELLED, STATUS_REMOVED]

interface StatusFilterProps {
  statusFilter: string[]
  setStatusFilter: (statuses: string[]) => void
}

const StatusFilter: React.FC<StatusFilterProps> = ({ statusFilter, setStatusFilter }) => {
  const allSelected = statusFilter.length === STATUSES.length

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value
    // On autofill we get a stringified value, need to parse it
    const newValue = typeof value === "string" ? value.split(",") : value
    // Preserve previous behavior: don't allow deselecting the last item
    if (newValue.length === 0) return
    setStatusFilter(newValue)
  }

  return (
    <div className="flex gap-2 items-center h-8" data-testid="panel-reservations-status-filter">
      <FormControl size="small" sx={{ minWidth: 150 }} className="h-full">
        <Select<string[]>
          multiple
          value={[...statusFilter]}
          onChange={handleChange}
          className={`h-full text-sm ${allSelected ? "" : "bg-blue-100 border border-blue-300"}`}
          input={<OutlinedInput className="h-full text-sm font-medium" />}
          aria-label={i18n.t("app.reservations_list.status_filter")}
          renderValue={() => i18n.t("app.reservations_list.status_filter")}
          MenuProps={MenuProps}
          data-testid="panel-reservations-status-filter-select"
        >
          {STATUSES.map((status) => (
            <MenuItem key={status} value={status} data-testid={`panel-reservations-status-filter-option-${status}`}>
              <Checkbox checked={statusFilter.includes(status)} />
              <ListItemText primary={LABELS[status]} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default StatusFilter
